export type AmbassadorGuideSection = {
  id: string;
  title: string;
  summary: string;
  roles: string[];
  steps: string[];
  notes?: string[];
  example?: { title: string; text: string };
};

export const ambassadorGuideRoles: {
  key: string;
  label: string;
  description: string;
}[] = [
  {
    key: "RECRUITER",
    label: "مسئول جذب",
    description:
      "بررسی درخواست‌ها، ثبت داوطلب، توضیح همکاری و واگذاری پرونده به پشتیبان.",
  },
  {
    key: "SUPPORT",
    label: "پشتیبان",
    description:
      "تکمیل ورود، فعال‌سازی، بررسی گزارش‌ها و پاسخ به پرونده‌های تخصیص‌یافته.",
  },
  {
    key: "CONTENT",
    label: "مسئول محتوا",
    description:
      "آماده‌سازی و انتشار آموزش، محتوای مرجع و مأموریت‌های اختیاری.",
  },
  {
    key: "SUPERVISOR",
    label: "سرپرست",
    description:
      "نظارت بر همه پرونده‌ها، ارزیابی هفتگی و مدیریت مسئولیت‌های تیم.",
  },
];

export const ambassadorGuideSections: AmbassadorGuideSection[] = [
  {
    id: "workflow",
    title: "از درخواست عضویت تا شروع فعالیت",
    summary: "مسیر کامل همکاری و تفاوت تأیید درخواست با فعال‌شدن سفیر.",
    roles: [],
    steps: [
      "ابتدا درخواست عضویت سایت را بررسی کنید: در «درخواست‌های عضویت»، اطلاعات داوطلب را بخوانید و نتیجه را ثبت کنید. برای معرفی تلفنی یا خارج از سایت، از «پرونده‌ها ← ثبت داوطلب» شروع کنید.",
      "تأیید درخواست، پرونده‌ای با وضعیت «در حال جذب» ایجاد می‌کند. سپس مسئولیت‌ها را توضیح دهید، پاسخ آگاهانه فرد را در «مراحل ورود» ثبت کنید و حساب سایت و پشتیبان را مشخص کنید.",
      "پشتیبان در «مراحل ورود»، آموزش و اقدامات ضروری را پس از انجام واقعی تأیید می‌کند. در «اطلاعات و پیگیری»، لینک کانال و اطلاعات لازم را ذخیره می‌کند.",
      "پس از تکمیل شرایط، پشتیبان یا سرپرست در «اطلاعات و پیگیری ← تغییر وضعیت»، گزینه «فعال» را با دلیل انتخاب می‌کند و «ثبت تغییر وضعیت» را می‌زند. حالا سفیر می‌تواند از پنل خودش گزارش فعالیت ثبت کند.",
      "بعد از شروع، گزارش‌ها و درخواست‌ها را پیگیری کنید، برای اقدامات بعدی موعد بگذارید و ارزیابی هفتگی را با مسئول مشخص ثبت کنید.",
    ],
    notes: [
      "پذیرش شرایط فرم درخواست، تأیید عضویت، ثبت موافقت همکاری و فعال‌سازی چهار اقدام جدا هستند؛ هیچ‌کدام جای مرحله بعدی را نمی‌گیرد.",
      "این پنل پیامک، پیام تلگرام، عضویت در کانال یا پیام خوشامدگویی را خودکار ارسال نمی‌کند. تماس، ارسال پیام و بررسی دسترسی کانال‌ها را تیم انجام می‌دهد و نتیجه را در پنل ثبت می‌کند.",
      "بخش‌های قابل مشاهده و دکمه‌های قابل استفاده به مسئولیت شما بستگی دارند. فیلتر نقش در این راهنما فقط برای پیدا کردن مطالب مرتبط است.",
    ],
  },
  {
    id: "daily",
    title: "برنامه روزانه اپراتور و پشتیبان",
    summary: "ترتیب پیشنهادی رسیدگی، ثبت تماس‌ها و بستن کارهای روز.",
    roles: ["RECRUITER", "SUPPORT", "SUPERVISOR"],
    steps: [
      "روز را از «داشبورد و پیگیری» شروع کنید. «درخواست باز»، «پیگیری‌های موعدرسیده» و «ورودهای ناقص» را ببینید. با انتخاب نام هر نفر، پرونده او باز می‌شود.",
      "در «اطلاعات و پیگیری ← ثبت تماس و پیگیری»، نتیجه واقعی را با یکی از گزینه‌های «تماس موفق»، «بدون پاسخ»، «تماس ناموفق»، «یادداشت داخلی» یا «پیگیری روزانه پشتیبان» ثبت کنید و «ثبت در سابقه» را بزنید.",
      "برای کاری که نیاز به ادامه دارد، در اطلاعات پایه، «پیگیری بعدی (ساعت دستگاه)» را تعیین کنید و «ذخیره پرونده» را بزنید. نوشتن موعد داخل یادداشت به‌تنهایی، پرونده را وارد صف پیگیری نمی‌کند.",
      "در تب‌های «درخواست‌ها» و «گزارش فعالیت»، پاسخ یا بازخورد لازم را ثبت کنید. برای هر مانع، اقدام بعدی و فرد مسئول را روشن بنویسید.",
      "پشتیبان در پایان روز به «داشبورد و پیگیری ← چک‌لیست روزانه پشتیبان» برگردد، فقط کارهای انجام‌شده را علامت بزند، «جمع‌بندی امروز» را بنویسد و «ذخیره چک‌لیست امروز» را انتخاب کند.",
    ],
    notes: [
      "چک‌لیست روزانه، مربوط به خود اپراتور و روز جاری به وقت تهران است؛ جای ثبت نتیجه در سابقه هر پرونده را نمی‌گیرد.",
      "تعداد «درخواست باز» مربوط به پشتیبانی پرونده‌هاست؛ تعداد درخواست‌های عضویت بررسی‌نشده را کنار تب «درخواست‌های عضویت» ببینید.",
    ],
    example: {
      title: "نمونه یادداشت قابل پیگیری",
      text: "تماس برقرار شد؛ داوطلب در ساخت کانال ابهام دارد. پشتیبان فردا راهنمای ساخت کانال را توضیح می‌دهد و لینک را بررسی می‌کند. موعد پیگیری نیز در اطلاعات پرونده ثبت شد.",
    },
  },
  {
    id: "applications",
    title: "بررسی درخواست‌های ارسال‌شده از سایت",
    summary: "تأیید یا عدم پذیرش داوطلب، تعیین پشتیبان و پیام نتیجه.",
    roles: ["RECRUITER", "SUPERVISOR"],
    steps: [
      "وارد «درخواست‌های عضویت» شوید. فهرست ابتدا روی «در انتظار بررسی» است. برای یافتن فرد، نام، شماره همراه یا شهر را جست‌وجو کنید و «اعمال فیلتر» را بزنید؛ «تازه‌سازی» آخرین اطلاعات را می‌گیرد.",
      "یک درخواست را انتخاب کنید. مشخصات، زمان همکاری، انگیزه، تجربه و زمان پذیرش شرایط ارسال درخواست را بخوانید و در صورت نیاز، پیش از تصمیم با داوطلب هماهنگ کنید.",
      "برای پذیرش، در «نتیجه درخواست»، گزینه «تأیید و شروع فرایند همکاری» را نگه دارید. می‌توانید همین‌جا پشتیبان را تعیین کنید یا آن را به تکمیل پرونده موکول کنید. پیام شروع همکاری اختیاری است.",
      "برای نپذیرفتن، «عدم پذیرش درخواست» را انتخاب کنید و دلیل روشن و محترمانه‌ای با حداقل ۵ نویسه بنویسید. «بازبینی و ثبت نتیجه» را بزنید، متن را در پنجره تأیید بخوانید و تصمیم را نهایی کنید.",
      "پس از تأیید، «مشاهده پرونده سفیر» را بزنید و مراحل ورود را ادامه دهید. برای دیدن درخواست‌های قبلاً بررسی‌شده، فیلتر وضعیت را به «تأییدشده»، «پذیرفته‌نشده» یا «همه درخواست‌ها» تغییر دهید.",
    ],
    notes: [
      "پیام بررسی، از جمله دلیل عدم پذیرش، در حساب خود داوطلب نمایش داده می‌شود؛ یادداشت داخلی یا اطلاعات محرمانه تیم را اینجا ننویسید.",
      "تأیید درخواست، سفیر را فعال نمی‌کند و هیچ مسئولیت مدیریتی به حساب او نمی‌دهد. پرونده به حساب ارسال‌کننده درخواست متصل می‌شود و مراحل ورود هنوز باید تکمیل شوند.",
      "داوطلبی که درخواستش پذیرفته نشده می‌تواند همان درخواست را ویرایش و دوباره ارسال کند؛ در این صورت دوباره «در انتظار بررسی» می‌شود. این حالت با پرونده بسته‌شده «رد همکاری» متفاوت است.",
    ],
  },
  {
    id: "profiles",
    title: "ثبت دستی، اتصال حساب و واگذاری پرونده",
    summary:
      "اطلاعات درست را به حساب درست متصل کنید و مسئول پیگیری را مشخص کنید.",
    roles: ["RECRUITER", "SUPERVISOR"],
    steps: [
      "پیش از ثبت دستی، در «پرونده‌ها» نام یا شماره فرد را جست‌وجو کنید و «اعمال فیلتر» را بزنید. درخواست سایت او را هم بررسی کنید تا برای یک نفر، کار موازی ایجاد نشود.",
      "اگر پرونده ندارد، «ثبت داوطلب» را بزنید؛ نام و نام خانوادگی الزامی است. تلفن، شناسه تلگرام و منبع معرفی را به اندازه نیاز وارد کنید و در صورت مشخص‌بودن، حساب سایت و پشتیبان را انتخاب کنید. سپس «ایجاد پرونده» را بزنید.",
      "برای اتصال حساب، در «اطلاعات و پیگیری» از بخش انتخاب کاربر سایت استفاده کنید: حداقل دو نویسه از نام، تلفن یا نام کاربری را بنویسید، «جست‌وجو» را بزنید، مشخصات نتیجه را تطبیق دهید و روی فرد درست کلیک کنید.",
      "در همان فرم، پشتیبان را از فهرست انتخاب کنید. لینک کانال تلگرام و تعداد اعضا را ثبت کنید؛ موعد را در «پیگیری بعدی (ساعت دستگاه)» با توجه به ساعت و منطقه زمانی دستگاه وارد کنید و «ذخیره پرونده» را بزنید.",
      "برای تغییر پشتیبان، مسئول جذب یا سرپرست پرونده را باز کند، پشتیبان جدید را انتخاب و ذخیره کند. پس از واگذاری، پرونده در محدوده رسیدگی پشتیبان جدید قرار می‌گیرد.",
    ],
    notes: [
      "ثبت تلفن یا شناسه تلگرام، اتصال حساب سایت محسوب نمی‌شود. تا حساب درست متصل نشود، فرد پرونده را در پنل خودش نمی‌بیند. اگر حساب ندارد، ابتدا باید در سایت ثبت‌نام کند.",
      "هر حساب سایت فقط به یک پرونده سفیری متصل می‌شود. خطای تکراری‌بودن حساب را با یافتن پرونده موجود پیگیری کنید.",
      "تغییر حساب متصل و واگذاری پشتیبان فقط در اختیار مسئول جذب یا سرپرست است؛ پشتیبان به‌تنهایی این دو مورد را تغییر نمی‌دهد.",
    ],
  },
  {
    id: "onboarding",
    title: "موافقت همکاری و چک‌لیست ورود",
    summary:
      "همه پیش‌نیازهای فعال‌سازی، با ترتیب انجام و تأیید واقعی هر مرحله.",
    roles: ["RECRUITER", "SUPPORT", "SUPERVISOR"],
    steps: [
      "در پرونده «در حال جذب»، تب «مراحل ورود» و متن «ثبت نتیجه پذیرش» را بخوانید. مسئولیت‌ها، داوطلبانه‌بودن مأموریت‌ها و امکان انصراف را توضیح دهید. فقط پس از دریافت پاسخ آگاهانه فرد، «موافقت دریافت شد» را بزنید؛ وضعیت به «در حال راه‌اندازی» می‌رود.",
      "اگر فرد تمایلی ندارد، «رد همکاری؛ توقف جذب» را انتخاب و پنجره تأیید را بررسی کنید. پرونده با وضعیت «رد همکاری» بسته می‌شود؛ این گزینه را برای تعویق تماس یا مانع موقت استفاده نکنید.",
      "پشتیبان پس از موافقت، ارتباط تلگرامی را برقرار کند، پیام خوشامدگویی و راهنمای ورود را خودش بفرستد، ساخت کانال خصوصی و نام، تصویر و توضیحات آن را بررسی کند و دسترسی واقعی به دو کانال مرجع را تأیید کند.",
      "اطلاعات پرونده را کامل کنید، شیوه انتشار، مأموریت و گزارش‌دهی را آموزش دهید و آمادگی فرد را بررسی کنید. سپس موارد انجام‌شده را در «چک‌لیست ورود» علامت بزنید. مورد پذیرش آگاهانه از دکمه ثبت موافقت تکمیل می‌شود و دستی قابل تغییر نیست.",
      "برای فعال‌سازی باید موافقت ثبت شده باشد، همه موارد «ضروری» چک‌لیست انجام شده باشند و حساب سایت، پشتیبان و لینک کانال در پرونده وجود داشته باشند. در «اطلاعات و پیگیری ← تغییر وضعیت»، «فعال» را انتخاب کنید، دلیل بنویسید و ثبت کنید.",
    ],
    notes: [
      "دو مورد «دعوت رضایت‌مندانه مخاطبان؛ هدف توسعه ۱۰۰ عضو» و «افزودن گفت‌وگو به فولدر سفیران» اختیاری‌اند. رسیدن به ۱۰۰ عضو شرط فعال‌سازی نیست.",
      "فقط پشتیبان یا سرپرست چک‌لیست را تکمیل و سفیر را فعال می‌کند. مسئول جذب می‌تواند نتیجه موافقت را ثبت کند، اما بدون مسئولیت پشتیبانی، چک‌لیست را تغییر نمی‌دهد.",
      "هر تأیید چک‌لیست همراه با زمان و مسئول ثبت می‌شود. ثبت تیک، آموزش، ارسال پیام یا ایجاد کانال را انجام نمی‌دهد؛ ابتدا اقدام واقعی را انجام دهید.",
    ],
  },
  {
    id: "statuses",
    title: "تغییر وضعیت، توقف موقت و پایان همکاری",
    summary: "معنای وضعیت‌ها و انتخاب درست برای مانع، توقف یا انصراف.",
    roles: ["SUPPORT", "SUPERVISOR"],
    steps: [
      "«در حال جذب» یعنی پاسخ همکاری هنوز ثبت نشده؛ «در حال راه‌اندازی» یعنی موافقت ثبت شده و مراحل ورود در حال تکمیل است. این دو وضعیت از مسیر پذیرش مدیریت می‌شوند.",
      "«فعال» را برای فرد آماده فعالیت انتخاب کنید. «نیازمند پشتیبانی» برای مانعی است که به رسیدگی نیاز دارد؛ سفیری که قبلاً فعال شده در این وضعیت هم می‌تواند گزارش بدهد. «موقتاً غیرفعال» برای توقف موقت است و ثبت گزارش در آن در دسترس نیست.",
      "برای تغییر، در «اطلاعات و پیگیری ← تغییر وضعیت»، «وضعیت بعدی» و «دلیل و اقدام بعدی» را کامل کنید و «ثبت تغییر وضعیت» را بزنید. بازگشت از توقف موقت به «فعال» دوباره به شرایط کامل فعال‌سازی نیاز دارد.",
      "اگر باید یکی از موارد ضروری چک‌لیست سفیر فعال را از تأیید خارج کنید یا حساب، پشتیبان یا لینک کانال ضروری را حذف کنید، ابتدا وضعیت را به «نیازمند پشتیبانی» تغییر دهید؛ سپس اصلاح را انجام دهید.",
      "«انصراف‌داده» پایان همکاری است. فقط مطابق درخواست فرد، با دلیل روشن و پس از بازبینی پنجره تأیید ثبت کنید. سپس در تب «درخواست‌ها»، بخش «پیگیری پایان همکاری» را برای ثبت نتیجه اقدامات خروج استفاده کنید.",
    ],
    notes: [
      "«انصراف‌داده» و «رد همکاری» پرونده‌های بسته‌اند؛ در این نسخه امکان فعال‌سازی مجدد یا بازکردن این پرونده‌ها وجود ندارد. «موقتاً غیرفعال» با انصراف فرق دارد.",
      "پس از انصراف، ثبت فعالیت و دسترسی محتوای سفیر بسته می‌شود. خروج از کانال‌های تلگرام و رسیدگی به درخواست‌های اطلاعات شخصی باید جداگانه توسط تیم پیگیری شود؛ گفت‌وگوی پشتیبانی برای پیگیری خروج باز می‌ماند.",
    ],
  },
  {
    id: "reports",
    title: "گزارش فعالیت و ارزیابی هفتگی",
    summary:
      "ارزیابی انسانی، بازخورد قابل مشاهده برای سفیر و برنامه اقدام هفته بعد.",
    roles: ["SUPPORT", "SUPERVISOR"],
    steps: [
      "در پرونده، «گزارش فعالیت» را باز کنید. روز گزارش، خلاصه کار یا مانع، تعداد انتشار، تعامل معنادار و در صورت وجود «شاهد فعالیت» و مأموریت را بررسی کنید. برای سوابق قبلی، «نمایش موارد قدیمی‌تر» همان بخش را بزنید.",
      "پشتیبان یا سرپرست، «کیفیت محتوا (۱ تا ۵)» و بازخورد روشن و اجرایی را وارد کند و «ثبت ارزیابی» را بزند. این امتیاز ارزیابی انسانی است و بازخورد در پنل خود سفیر دیده می‌شود.",
      "سرپرست برای جمع‌بندی، تب «ارزیابی هفتگی» را باز کند و «شروع بازه هفت‌روزه» را روی روز شروع موردنظر، حداکثر امروز، قرار دهد. استمرار، کیفیت، مشارکت واقعی و مشکلات حل‌شده را بررسی کند.",
      "در «تصمیم سرپرست»، یکی از «ادامه فعالیت»، «آموزش مجدد»، «پیگیری و رفع مانع» یا «پیشنهاد توقف موقت» را انتخاب کنید. «جمع‌بندی ارزیابی» و «اقدام بعدی و مسئول پیگیری» را بنویسید و «ثبت ارزیابی هفتگی» را بزنید.",
      "اگر تصمیم به تغییر وضعیت نیاز دارد، آن را جداگانه از «اطلاعات و پیگیری ← تغییر وضعیت» ثبت کنید. برای یک پرونده و یک تاریخ شروع یکسان، ثبت دوباره ارزیابی هفتگی، ارزیابی همان بازه را به‌روز می‌کند.",
    ],
    notes: [
      "سفیر پس از اولین فعال‌سازی، فقط در وضعیت «فعال» یا «نیازمند پشتیبانی» می‌تواند گزارش ثبت کند؛ صرف تغییر به «نیازمند پشتیبانی» پیش از فعال‌سازی، گزارش‌دهی را باز نمی‌کند.",
      "تعداد اعضا، انتشار و تعامل، اطلاعات اعلام‌شده توسط سفیرند و خودکار از تلگرام خوانده نمی‌شوند. قبل از قضاوت، شواهد و توضیح فرد را بررسی کنید.",
      "ارزیابی هفتگی برای تیم داخلی است و در پنل سفیر نمایش داده نمی‌شود؛ بازخورد گزارش و پاسخ پشتیبانی برای سفیر قابل مشاهده‌اند.",
    ],
    example: {
      title: "نمونه بازخورد سازنده",
      text: "انتخاب موضوع‌ها مرتبط بود. در انتشار بعدی، منبع مطلب را هم درج کنید. برای ابهام در ثبت گزارش، پشتیبان تا فردا یک نمونه را همراه شما مرور می‌کند.",
    },
  },
  {
    id: "support",
    title: "پاسخ‌گویی به درخواست‌ها و پیگیری خروج",
    summary: "ادامه گفت‌وگو، ثبت رسیدگی و تفاوت پاسخ عمومی با یادداشت داخلی.",
    roles: ["SUPPORT", "SUPERVISOR"],
    steps: [
      "پرونده را باز کنید و به تب «درخواست‌ها» بروید. عنوان، وضعیت «باز» یا «رسیدگی‌شده» و تمام پیام‌های قبلی سفیر و تیم پشتیبانی را بخوانید.",
      "در فیلد «پاسخ»، توضیح روشن یا سؤال لازم برای ادامه رسیدگی را بنویسید و «ارسال پاسخ» را بزنید. این متن در گفت‌وگوی پشتیبانی خود سفیر نمایش داده می‌شود.",
      "پس از حل مسئله، «علامت‌گذاری رسیدگی‌شده» را بزنید؛ ارسال پاسخ به‌تنهایی درخواست را نمی‌بندد. اگر نیاز به ادامه بررسی بود، «بازگشایی درخواست» را انتخاب کنید.",
      "برای توضیح داخلی، از «اطلاعات و پیگیری ← ثبت تماس و پیگیری ← یادداشت داخلی» استفاده کنید. سابقه داخلی با پاسخ درخواست فرق دارد و به سفیر نمایش داده نمی‌شود.",
      "در پرونده بسته، حذف دسترسی کانال‌ها و درخواست‌های مربوط به اطلاعات شخصی را پیگیری کنید و نتیجه را در «پیگیری پایان همکاری ← نتیجه پیگیری» بنویسید و «ثبت در سابقه» را بزنید. گفت‌وگوی پشتیبانی همچنان برای ادامه پیگیری قابل استفاده است.",
    ],
    notes: [
      "درخواست پشتیبانی با درخواست عضویت سایت متفاوت است؛ اولی در تب «درخواست‌ها»ی هر پرونده و دومی در «درخواست‌های عضویت» بررسی می‌شود.",
      "ثبت یادداشت، پاسخ یا انصراف به معنی ارسال پیام خودکار بیرون از سایت یا حذف خودکار عضویت تلگرام نیست.",
    ],
  },
  {
    id: "resources",
    title: "آموزش، محتوای مرجع و مأموریت‌های اختیاری",
    summary: "از پیش‌نویس تا انتشار محتوای قابل استفاده در پنل سفیر.",
    roles: ["CONTENT", "SUPERVISOR"],
    steps: [
      "به «محتوا و مأموریت» بروید. در «آموزش، محتوا و کانال‌های مرجع» می‌توانید «افزودن بسته آغازین SOP» را بزنید؛ آموزش‌ها و متن‌های آماده به شکل پیش‌نویس اضافه می‌شوند.",
      "در «محتوای جدید» یا «ویرایش محتوا»، نوع مناسب را انتخاب کنید: «آموزش»، «محتوا»، «اطلاعیه»، «کانال مرجع» یا «متن آماده». عنوان، متن و در صورت نیاز لینک معتبر را کامل کنید و «ذخیره محتوا» را بزنید.",
      "متن نمونه‌ها، نام مسئولان و لینک‌های مجموعه را پیش از انتشار بازبینی کنید. از دکمه «انتشار» روی کارت یا گزینه «انتشار برای سفیران» در فرم استفاده کنید؛ برای پنهان‌کردن از پنل سفیر، «برداشتن از انتشار» را بزنید.",
      "در «مأموریت‌های اختیاری»، عنوان، هدف، «اقدام پیشنهادی و شیوه گزارش نتیجه» و در صورت نیاز لینک و مهلت را مشخص کنید. پس از بازبینی، گزینه «انتشار» و سپس «ذخیره مأموریت» را بزنید؛ زمان مهلت بر اساس ساعت دستگاه وارد می‌شود.",
      "لینک‌های کانال مرکزی و کانال محتوا را به‌عنوان «کانال مرجع» منتشر کنید و دسترسی واقعی سفیر را جداگانه بررسی کنید. انتشار لینک به معنی عضوکردن فرد در کانال نیست.",
    ],
    notes: [
      "پیش‌نویس برای سفیر نمایش داده نمی‌شود. سفیر پس از ثبت موافقت، محتوای منتشرشده را می‌بیند؛ پرونده‌های انصراف‌داده و رد همکاری به این محتوا دسترسی ندارند.",
      "مأموریت‌ها داوطلبانه‌اند. مأموریت منتشرنشده یا دارای مهلت گذشته را نمی‌توان به گزارش جدید وصل کرد. انتشار مأموریت پیام تلگرام ارسال نمی‌کند.",
      "متن‌ها به‌صورت ساده نمایش داده می‌شوند؛ از عنوان روشن و بندهای کوتاه استفاده کنید. فهرست محتوا و مأموریت، حداکثر ۲۰۰ مورد اخیر هر بخش را نشان می‌دهد.",
    ],
  },
  {
    id: "dashboard",
    title: "خواندن داشبورد، فیلترها و خروجی اکسل",
    summary: "تعریف شاخص‌ها و تهیه خروجی از پرونده‌های قابل دسترسی.",
    roles: ["RECRUITER", "SUPPORT", "SUPERVISOR"],
    steps: [
      "در «داشبورد و پیگیری»، کارت‌های «کل پرونده‌ها»، «سفیر فعال»، «ورود ناقص» و «درخواست باز» را ببینید. این اعداد فقط پرونده‌های قابل دسترسی شما را پوشش می‌دهند و با داشبورد همکار دارای مسئولیت دیگر لزوماً یکسان نیستند.",
      "در «ارزیابی ۷ روز اخیر»، بازه شامل امروز و شش روز قبل به وقت تهران است. «مبنای محاسبه شاخص‌ها» را باز کنید تا تعریف دقیق نرخ‌ها را ببینید؛ «—» یعنی داده کافی برای محاسبه نسبت وجود ندارد.",
      "«نرخ پذیرش» نسبت موافقت‌های مربوط به تماس‌های موفق این بازه به تعداد تماس‌های موفق است؛ تماس موفق تکراری هم در تعداد تماس‌ها حساب می‌شود. «تکمیل ورود» سهم افراد فعال‌شده از گروهی است که در همین هفت روز موافقت کرده‌اند.",
      "«استمرار فعالیت» روزهای دارای انتشار، تعامل یا اقدام انجام‌شده در چک‌لیست را نسبت به روزهای برنامه روزانه پس از فعال‌سازی می‌سنجد؛ روزهای پایان‌یافته در حالت توقف کنار گذاشته می‌شوند. صرف ثبت گزارش مانع، فعالیت محسوب نمی‌شود.",
      "«رسیدگی پشتیبانی» سهم درخواست‌های حل‌شده از درخواست‌های ایجادشده در هفت روز اخیر است. «کیفیت محتوا» میانگین امتیاز انسانی گزارش‌های بررسی‌شده از ۵ است. تعداد انتشار و تعامل، جمع اطلاعات ثبت‌شده گزارش‌هاست.",
      "برای فهرست یا خروجی، به «پرونده‌ها» بروید، جست‌وجو، «وضعیت» و «پشتیبان» را تنظیم کنید و «اعمال فیلتر» را بزنید. «خروجی اکسل» همان فیلترها و محدودیت دسترسی شما را رعایت می‌کند. برای برگشت، «پاک کردن فیلترها» را بزنید.",
    ],
    notes: [
      "داشبورد هدف عددی یا رتبه‌بندی خودکار تعیین نمی‌کند. نرخ پایین را همراه با تعداد داده‌ها، سابقه و شرایط واقعی پرونده‌ها بررسی کنید.",
      "خروجی اکسل شامل اطلاعات اشخاص است؛ آن را فقط در اختیار افراد مسئول و به میزان نیاز قرار دهید.",
    ],
  },
  {
    id: "team",
    title: "تیم، مسئولیت‌ها و محدوده دسترسی",
    summary: "تعریف وظایف همکاران و واگذاری پرونده‌ها پیش از حذف مسئولیت.",
    roles: ["SUPERVISOR"],
    steps: [
      "در «تیم و دسترسی‌ها»، مسئولیت‌های فعلی هر همکار را ببینید. برای فرد موجود «ویرایش مسئولیت‌ها» را بزنید؛ برای فرد جدید، در «ثبت یا جایگزینی دسترسی» حساب فعال سایت او را جست‌وجو و انتخاب کنید.",
      "«مسئول جذب» درخواست‌های عضویت را بررسی و داوطلب ثبت می‌کند؛ پرونده‌های در حال جذب، در حال راه‌اندازی و رد همکاری و نیز پرونده‌هایی را که خودش جذب کرده می‌بیند. مسئولیت جذب به‌تنهایی مجوز فعال‌سازی یا پاسخ پشتیبانی نمی‌دهد.",
      "«پشتیبان» به پرونده‌های تخصیص‌یافته خودش دسترسی دارد و مراحل ورود، وضعیت، گزارش و درخواست‌ها را رسیدگی می‌کند. اگر هم‌زمان مسئولیت جذب هم داشته باشد، محدوده دسترسی هر دو مسئولیت را خواهد داشت.",
      "«مسئول محتوا» آموزش، محتوا و مأموریت‌ها را مدیریت می‌کند و با این مسئولیت به‌تنهایی پرونده‌های شخصی را نمی‌بیند. «سرپرست» به همه بخش‌های سفیران دسترسی دارد؛ مدیر اصلی سایت نیز دسترسی کامل دارد.",
      "همه مسئولیت‌هایی را که فرد باید نگه دارد علامت بزنید و «ذخیره دسترسی» را بزنید. انتخاب‌ها جایگزین مسئولیت‌های قبلی می‌شوند؛ انتخاب نکردن هیچ مسئولیتی یعنی حذف دسترسی ماژول. قبل از نهایی‌کردن، پنجره تأیید را بخوانید.",
      "پیش از حذف مسئولیت پشتیبانی یا سرپرستی یک نفر، پرونده‌های باز تخصیص‌یافته او را از «اطلاعات و پیگیری» به پشتیبان دیگری واگذار کنید؛ تا آن زمان حذف مسئولیت پشتیبانی انجام نمی‌شود.",
    ],
    notes: [
      "مسئولیت‌های تیم سفیران با سفیرشدن کاربر متفاوت‌اند. تأیید درخواست عضویت یا ساخت پرونده، کاربر را به اپراتور یا مدیر تبدیل نمی‌کند.",
      "مسئولیت‌ها قابل ترکیب‌اند. مجوزی را انتخاب کنید که برای انجام وظیفه فرد لازم است.",
    ],
  },
  {
    id: "troubleshooting",
    title: "رفع موانع متداول و تشخیص نتیجه ثبت",
    summary:
      "وقتی پرونده پیدا نمی‌شود، دکمه غیرفعال است یا نتیجه ثبت روشن نیست.",
    roles: [],
    steps: [
      "«پرونده پیدا نمی‌شود»: در «پرونده‌ها»، «پاک کردن فیلترها» را بزنید و دوباره جست‌وجو کنید. پشتیبان فقط پرونده‌های تخصیص‌یافته را می‌بیند؛ از سرپرست بخواهید حساب و واگذاری را بررسی کند.",
      "«سفیر پرونده خودش را نمی‌بیند»: مسئول جذب یا سرپرست در «اطلاعات و پیگیری»، حساب متصل را با حسابی که فرد با آن وارد سایت شده تطبیق دهد و ذخیره کند. صرف یکسان‌بودن تلفن نوشته‌شده در پرونده کافی نیست.",
      "«چک‌لیست غیرفعال است»: موافقت باید ثبت شده و پرونده باز باشد و شما مسئولیت پشتیبانی یا سرپرستی داشته باشید. مورد پذیرش آگاهانه فقط از «موافقت دریافت شد» تکمیل می‌شود.",
      "«فعال‌سازی انجام نمی‌شود»: پیام خطا و کارت «آمادگی پرونده» را بخوانید؛ موافقت، همه موارد ضروری، اتصال حساب، پشتیبان و لینک کانال را تکمیل کنید. هدف ۱۰۰ عضو و فولدر تلگرام مانع فعال‌سازی نیستند.",
      "«لینک کانال پذیرفته نمی‌شود»: آدرس کامل تلگرام را با https و دامنه t.me یا telegram.me وارد کنید؛ شناسه تنها یا لینک سایت دیگر، لینک کانال محسوب نمی‌شود.",
      "«نتیجه ثبت شده ولی فهرست تازه نشده»: اگر پیام ثبت موفق یا هشدار ثبت نتیجه همراه با ناموفق‌بودن تازه‌سازی می‌بینید، درخواست را دوباره ثبت نکنید؛ ابتدا فهرست را تازه‌سازی و نتیجه فعلی را بررسی کنید.",
      "«ارسال پیام انجام نشده»: ثبت نتیجه، انتشار محتوا یا تیک خوشامدگویی، پیام بیرون از سایت نمی‌فرستد. ارسال واقعی را طبق روال تیم انجام دهید؛ برای پیگیری خطا، متن خطا، نام بخش و زمان وقوع را بدون رمز عبور یا اطلاعات اضافی برای مسئول فنی ثبت کنید.",
    ],
    notes: [
      "اگر گزینه‌ای را نمی‌بینید، ابتدا مسئولیت خود را با سرپرست بررسی کنید. راهنما همه گردش کار را توضیح می‌دهد، اما مجوز جدیدی ایجاد نمی‌کند.",
      "برای مشاهده نتیجه، پیام موفقیت و وضعیت فعلی پرونده را بررسی کنید. پرونده‌های «انصراف‌داده» و «رد همکاری» در این نسخه دوباره فعال نمی‌شوند.",
    ],
    example: {
      title: "نمونه لینک قابل قبول کانال",
      text: "https://t.me/+YOUR_CHANNEL_INVITE — از لینک واقعی کانال خود سفیر استفاده کنید و دسترسی آن را جداگانه بررسی کنید.",
    },
  },
];
